﻿import { v1_3_request_booking_search_criteria_date} from "./v1_3_request_booking_search_criteria_date";

export class v1_3_request_booking_search_criteria_date_range {
        public date_equal: v1_3_request_booking_search_criteria_date = new v1_3_request_booking_search_criteria_date();
        public date_greater_than: v1_3_request_booking_search_criteria_date = new v1_3_request_booking_search_criteria_date();
        public date_less_than: v1_3_request_booking_search_criteria_date = new v1_3_request_booking_search_criteria_date();

}